import { MercureTopics } from './MercureTopics';
import type { MercureEventListener, MercureListenersState, MercureMessage } from './types';

export class MercureObserver {
    private listeners: MercureListenersState;
    private topics: MercureTopics;

    constructor() {
        this.listeners = {};
        this.topics = new MercureTopics();
    }

    addListener(topic: string, type: string, listener: MercureEventListener) {
        this.topics.addTopic(topic);

        const typeListeners = this.listeners[type];

        if (!typeListeners) {
            this.listeners[type] = [listener];

            return;
        }

        this.listeners[type] = [...typeListeners, listener];
    }

    removeListener(topic: string, type: string, listener: MercureEventListener) {
        this.topics.removeTopic(topic);

        const typeListeners = this.listeners[type];

        if (!typeListeners) {
            return;
        }

        const nextTypeListeners = typeListeners.filter((item) => item !== listener);

        if (nextTypeListeners.length < 1) {
            delete this.listeners[type];
        } else {
            this.listeners[type] = nextTypeListeners;
        }
    }

    clean() {
        this.topics.clean();
        this.listeners = {};
    }

    emitEvent(type: string, event: MercureMessage) {
        const typeListeners = this.listeners[type];

        if (!typeListeners) {
            return;
        }

        typeListeners.forEach((listener) => listener(event));
    }

    getListeners(): Readonly<MercureListenersState> {
        return this.listeners;
    }

    getTypes(): string[] {
        return Object.keys(this.listeners);
    }

    hasType(type: string): boolean {
        return !!this.listeners[type];
    }

    getTopics(): string[] {
        return this.topics.getTopics();
    }

    hasTopic(topic: string): boolean {
        return this.topics.hasTopic(topic);
    }
}
